import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AddWarrantyServiceModel, DurationValueModel } from 'src/app/models/warrantyService/warrantyService.model';
import { UpdateWarrantyServiceModel } from 'src/app/models/warrantyService/warrantyServiceUpdate';
import { environment } from 'src/environments/environment';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';
import { CurrencyPipe } from '@angular/common';


@Component({
  selector: 'app-warranty-service-update',
  templateUrl: './warranty-service-update.component.html',
  styleUrls: ['./warranty-service-update.component.css']
})
export class WarrantyServiceUpdateComponent implements OnInit {
  Loader: boolean = false;
  tinyMCEkey: string;
  updateWarrantyService: AddWarrantyServiceModel;
  UpdateWarrantyServiceModel: UpdateWarrantyServiceModel;
  id: number;
  price1: string;
  price2: string;
  price3: string;
  price4: string;
  price5: string;
  installationPrices: string;
  selectedActiveValue: string;
  featureEditorElement: '';
  formattedAmount;

  constructor(private currencyPipe : CurrencyPipe,private _warrantyServiceService: WarrantyServiceService, private alertify: AlertifyService, private route: Router, private router: ActivatedRoute) {
    this.updateWarrantyService = new AddWarrantyServiceModel();
    this.UpdateWarrantyServiceModel = new UpdateWarrantyServiceModel();
  }

  ngOnInit() {
    this.tinyMCEkey = environment.tinyMCEKey;
    this.router.params.subscribe((param) => {
      this.id = +param.id;

    })
    this.getWarrantyServiceId();
  }
 
  transformAmount() {
    var ele = document.getElementById('warrantyPrice1') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
  }

  transformPrice2() {
    var ele = document.getElementById('warrantyPrice2') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
  }

  transformPrice3() {
    var ele = document.getElementById('warrantyPrice3') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
  }

  transformPrice4() {
    var ele = document.getElementById('warrantyPrice4') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
  }

  transformPrice5() {
    var ele = document.getElementById('warrantyPrice5') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
  }

  transformPrice6() {
    var ele = document.getElementById('warrantyPrice6') as HTMLButtonElement | null;
    ele.value = this.currencyPipe.transform(ele.value, '$');
  }
  showWarrantyServiceValue() {
    var featureEditorElement: HTMLIFrameElement = document.getElementById('Features_ifr') as HTMLIFrameElement;
    featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML = this.UpdateWarrantyServiceModel.warrantyServiceTerm;
    this.updateWarrantyService.WarrantyServiceTerm = featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
  }

  getWarrantyServiceId() {
    this.Loader = true;
    this._warrantyServiceService.getWarrantyServiceId(this.id)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.UpdateWarrantyServiceModel = responseBody.responseData;
        this.updateWarrantyService.Title = this.UpdateWarrantyServiceModel.title;
        this.updateWarrantyService.Duration = this.UpdateWarrantyServiceModel.duration;
        this.updateWarrantyService.WarrantyServiceTerm = this.UpdateWarrantyServiceModel.warrantyServiceTerm;
        this.updateWarrantyService.IsActive = this.UpdateWarrantyServiceModel.isActive;
        this.selectedActiveValue = this.updateWarrantyService.IsActive ? "1" : "0";
        setTimeout(() => {
          this.showWarrantyServiceValue();
          this.transformAmount();
          this.transformPrice2();
          this.transformPrice3();
          this.transformPrice4();
          this.transformPrice5();
          this.transformPrice6();
        }, 700);
        this.updateWarrantyService.Duration = this.UpdateWarrantyServiceModel.duration;
        var durationWithPrizeList = JSON.parse(this.updateWarrantyService.Duration);
        for (var i = 0; i < durationWithPrizeList.length; i++) {
          if (durationWithPrizeList[i].Duration == "1") {
            this.price1 = durationWithPrizeList[i].Price;
          } else if (durationWithPrizeList[i].Duration == "2") {
            this.price2 = durationWithPrizeList[i].Price;
          } else if (durationWithPrizeList[i].Duration == "3") {
            this.price3 = durationWithPrizeList[i].Price;
          } else if (durationWithPrizeList[i].Duration == "4") {
            this.price4 = durationWithPrizeList[i].Price;
          }
          else if (durationWithPrizeList[i].Duration == "5") {
            this.price5 = durationWithPrizeList[i].Price;
          }
           else {
            this.installationPrices = durationWithPrizeList[i].Price;
          }
        }
        this.Loader = false;
      });
  }

  onSubmit() {
    var priceDuration1 = new DurationValueModel();
    priceDuration1.Duration = "1";
    priceDuration1.Price = this.price1;

    var priceDuration2 = new DurationValueModel();
    priceDuration2.Duration = "2";
    priceDuration2.Price = this.price2;

    var priceDuration3 = new DurationValueModel();
    priceDuration3.Duration = "3";
    priceDuration3.Price = this.price3;

    var priceDuration4 = new DurationValueModel();
    priceDuration4.Duration = "4";
    priceDuration4.Price = this.price4;

    var priceDuration5 = new DurationValueModel();
    priceDuration5.Duration = "5";
    priceDuration5.Price = this.price5;

    var installationPrice = new DurationValueModel();
    installationPrice.Duration ="installationPrice"; 
    installationPrice.Price = this.installationPrices;

    var durations = new Array<DurationValueModel>();
    durations.push(priceDuration1);
    durations.push(priceDuration2);
    durations.push(priceDuration3);
    durations.push(priceDuration4);
    durations.push(priceDuration5);
    durations.push(installationPrice);

    this.updateWarrantyService.Duration = JSON.stringify(durations);

    var featureEditorElement: HTMLIFrameElement = document.getElementById('Features_ifr') as HTMLIFrameElement
    this.updateWarrantyService.WarrantyServiceTerm = featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;


    if (this.updateWarrantyService.Title == undefined || this.updateWarrantyService.Title == null || this.updateWarrantyService.Title == "") {
      this.alertify.error("Title Name is required");
      return;
    }

    this.Loader = true;
    this.updateWarrantyService.IsActive = this.selectedActiveValue;
    this.updateWarrantyService.Id = this.id;
    this._warrantyServiceService.updateWarrantyService(this.updateWarrantyService)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.updateWarrantyService = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
          this.route.navigate(['warranty-service-listing']);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;
      });
  }

  onCancel() {
    this.route.navigate(['warranty-service-listing']);
  }

  selectActive(selectedValue) {
    this.selectedActiveValue = selectedValue;
  }

}


